import {ChildEntity, ManyToOne, Relation} from "typeorm";
import {ShallowRef} from "vue";
import {Component} from "@vue/runtime-core";
import TransferNotificationComponent from "@/modules/transfer-market/components/TransferNotification.vue";
import {LocationAsRelativeRaw} from "vue-router";
import {Player, Team} from "@/modules/team/entity";
import {Notification} from "@/modules/notifications/entity";

type PayloadType = { playerId: number, playerName: string, inOut: InOutType, price: number };
type InOutType = 'in' | 'out';

@ChildEntity()
export class TransferNotification extends Notification {
  @ManyToOne(() => Team)
  declare target: Relation<Team>;

  setPayload(player: Player, price: number, inOut: InOutType) {
    this.payloadRaw = JSON.stringify({playerId: player.id, playerName: player.shortName, price, inOut});

    return this;
  }

  get payload(): PayloadType {
    return JSON.parse(this.payloadRaw!);
  }

  get component(): ShallowRef<Component> {
    return shallowRef(TransferNotificationComponent);
  }

  get to(): LocationAsRelativeRaw | undefined {
    return {name: 'players.show', params: {id: this.payload.playerId}};
  }
}